/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { PageSection } from 'src/sections/global/components/page.style';

export const SettingsPageLoadingWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60%',
});

export const SettingsPageIframe = styled.iframe<{
  isLoading: boolean;
  topOffset?: number;
}>(({ isLoading }) => ({
  display: isLoading ? 'none' : 'block',
  border: 'none',
  width: '100%',
  height: '100%',
}));

export const SettingsPageContainer = styled.div<{
  topOffset?: number;
}>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${({ topOffset }) =>
    topOffset ? `calc(100vh - ${topOffset}px)` : '100%'};
`;

export const SettingsPageSection = styled(PageSection)({
  display: 'flex',
  flex: 'auto',
  height: '100%',
});

// Using a custom GridColumn because atlaskit adds extra child div
export const SettingsPageWrapper = styled.div({
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
  margin: `0 ${token('space.250')}`,
  padding: `0 ${token('space.250')}`,
  wordWrap: 'break-word',
  marginBottom: token('space.800'),
});
